module.exports = __webpack_public_path__ + "static/img/content-31.42862a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/industrySolutions/content-31.png
// module id = 2zGe
// module chunks = 0